import { availableMoveSizes, availableMoveTypes, availableMoveSizeDetails, availableMoveSizeDetailsApartment } from "./data";
import moment from "moment";

var today = moment().format("MM/DD/YYYY");
var tomorrow = moment().add(1, 'days').format("MM/DD/YYYY");
console.dir("XYZ------------"+today);

export const moveWithFormFields = (lead: any = {}, couponDates: any[] = []) => {
    return {
        "formPages": [
            // {
            //     "id": "",
            //     "title": "How far are we moving you?",
            //     "key": "move",
            //     "shortTitle": "",
            //     "goNextOnValid": true,
            //     "clearAllSubPages": true,
            //     "fields": [
            //         {
            //             "fieldType": "singleSelect",
            //             "required": true,
            //             "formControlName": "MoveType",
            //             "value": "",
            //             "bindLabel": "label",
            //             "bindValue": "value",
            //             "options": availableMoveTypes(lead)
            //         },
            //     ]
            // },
            {
                "id": "",
                "title": "",
                "subTitle": "",
                "key": "bookingdetails",
                "shortTitle": "",
                "footer": false,
                "fields": [
                  {
                    "fieldType": "superDeals",
                    "formControlName": "superDeals",
                    "order": 1,
                  },
                ]
              },
 /*              {
                "id": "",
                // "title": "Moving Knowledge",
                // "subTitle": "Learn more about your available pricing options. Call us to speak to one of our moving experts for more information.",
                "key": "movingknowledge",
                "shortTitle": "",
                "footer": false,
                "fields": [
                  {
                    "fieldType": "movingKnowledge",
                    "formControlName": "movingKnowledge",
                    "order": 1,
                  },
                ]
              }, */
              // {
              //   "id": "",
              //   "title": "",
              //   "subTitle": "",
              //   "key": "pricing",
              //   "shortTitle": "",
              //   "footer": false,
              //   "fields": [
              //     {
              //       "fieldType": "pricingOptions",
              //       "formControlName": "pricingOptions",
              //       "order": 1,
              //     },
              //   ]
              // },
              {
                "id": "",
                "title": "let’s finalize",
                "subTitle": "All that’s left is some quick signatures and a deposit that goes towards your final total.",
                "key": "toDo",
                "shortTitle": "",
                "footer": false,
                "fields": [
                  {
                    "fieldType": "toDo",
                    "formControlName": "toDo",
                    "order": 1,
                  },
                ]
              },
              {
                "id": "",
                "title": "",
                "subTitle": "",
                "key": "paperwork",
                "shortTitle": "",
                "footer": true,
                "fields": [
                  {
                    "fieldType": "MovePaperWork",
                    "formControlName": "sign",
                    "order": 1,
                  },
                ]
              },
              {
                "id": "",
                // "title": "Book your move",
                //"subTitle": "Pay a deposit of $"+(JSON.parse(localStorage.getItem("amounts") || '{}'))[1].amount+" and the rest on your move day.",
                "key": "deposit",
                "shortTitle": "",
                "footer": false,
                "fields": [
                  {
                    "fieldType": "payDeposit",
                    "order": 1,
                  },
                ]
              },
              {
                "id": "",
                // "title": "Book your move",
                //"subTitle": "Pay a deposit of $"+(JSON.parse(localStorage.getItem("amounts") || '{}'))[1].amount+" and the rest on your move day.",
                "key": "amslanding",
                "shortTitle": "",
                "footer": false,
                "fields": [
                  {
                    "fieldType": "amsLanding",
                    "order": 1,
                  },
                ]
              },
              
              {
                "id": "",
                // "title": "you’re All Set!",
                // "subTitle": "Let’s review everything before we book your move.",
                "key": "book",
                "shortTitle": "",
                "footer": false,
                "fields": [
                  {
                    "fieldType": "bookMove",
                    "order": 1,
                  },
                ]
              },
              {
                "id": "",
                // "title": "you’re All Set!",
                // "subTitle": "Let’s review everything before we book your move.",
                "key": "booked",
                "shortTitle": "",
                "footer": false,
                "fields": [
                  {
                    "fieldType": "movebooked",
                    "order": 1,
                  },
                ]
              },


              
            // {
            //     "id": "",
            //     "title": "We're moving your...",
            //     "key": "type",
            //     "shortTitle": "",
            //     "goNextOnValid": true,
            //     "clearAllSubPages": true,
            //     "fields": [
            //         {
            //             "fieldType": "singleSelect",
            //             "required": true,
            //             "formControlName": "MoveSize",
            //             "value": lead.MoveSize,
            //             "bindLabel": "value",
            //             "bindValue": "value",
            //             "options": availableMoveSizes(lead)
            //         },
            //     ]
            // },
            // {
            //     "id": "",
            //     "title": "What size is your move?",
            //     "key": "size",
            //     "shortTitle": "",
            //     "goNextOnValid": true,
            //     "fields": [
            //         {
            //             "fieldType": "singleSelect",
            //             "required": true,
            //             "formControlName": "MoveSizeDetail",
            //             "value": lead.MoveSizeDetail,
            //             "bindLabel": "value",
            //             "bindValue": "value",
            //             "options": availableMoveSizeDetails
            //         },
            //     ]
            // },
            // {
            //     "id": "",
            //     "title": "What Is Your Zip?",
            //     "key": "zip",
            //     "shortTitle": "",
            //     "goNextOnValid":false,
            //     "fields": [
            //         {
            //             "label": "Zip Code",
            //             "fieldType": "textField",
            //             "required": true,
            //             "formControlName": "Zipcode",
            //             "keyboardType": "tel",
            //             "validators": {
            //                 // Regex for USA phone pattern validation
            //                 "custom": /(^\d{5}$)|(^\d{5}-\d{4}$)/
            //             },
            //             "value": "",
            //             "order": 1
            //         },
            //         {
            //             "label": "Continue",
            //             "fieldType": "button",
            //             "formControlName": "Zipdone",
            //             "order": 2
            //         },
            //     ]
            // },
            // {
            //     "id": "",
            //     "title": "What Is Your Current Address?",
            //     "key": "address",
            //     "shortTitle": "",
            //     "goNextOnValid":false,
            //     "fields": [
            //         {
            //             "label": "Address",
            //             "fieldType": "address",
            //             // "required": true,
            //             "formControlName": "address",
            //             "keyboardType": "text",
            //             // "validators": {
            //             //     // Regex for USA phone pattern validation
            //             //     "custom": /(^\d{5}$)|(^\d{5}-\d{4}$)/
            //             // },
            //             "value": lead.Address,
            //             "order": 1
            //         },
            //         {
            //             "label": "Unit #",
            //             "fieldType": "textField",
            //             // "required": true,
            //             "formControlName": "Unit",
            //             "keyboardType": "text",
            //             // "validators": {
            //             //     // Regex for USA phone pattern validation
            //             //     "custom": /(^\d{5}$)|(^\d{5}-\d{4}$)/
            //             // },
            //             "value": lead.Unit,
            //             "order": 1
            //         },
            //         {
            //             "label": "Continue",
            //             "fieldType": "button",
            //             // "formControlName": "done",
            //             "order": 2
            //         },
            //     ]
            // },
            // {
            //     "id": "",
            //     "title": "Approximate Move Date",
            //     "subTitle": "You can easily change this later.",
            //     "key": "date",
            //     "shortTitle": "",
            //     "goNextOnValid": true,
            //     "footer": true,
            //     "fields": [
            //         {
            //             "fieldType": "datePicker",
            //             // "required": true,
            //             "formControlName": "MoveDate",
            //             "value": lead.MoveDate
            //         },
            //         // {
            //         //     "fieldType": "singleSelect",
            //         //     // "required": true,
            //         //     "formControlName": "MoveDate",
            //         //     "value": lead.MoveDate,
            //         //     "bindLabel": "label",
            //         //     "bindValue": "value",
            //         //     "options": [
            //         //         /* { "id": "", "label": "TODAY", "value": today },
            //         //         { "id": "", "label": "TOMORROW", "value": tomorrow  }, */
            //         //         { "id": "", "label": "I'M NOT SURE", "value": false }
            //         //       ]
            //         // },
            //     ]
            // },
            // {
            //     "id": "",
            //     "title": "",
            //     "subTitle": "",
            //     "key": "date",
            //     "shortTitle": "",
            //     "goNextOnValid": true,
            //     // "footer": true,
            //     "fields": [
            //         {
            //             "fieldType": "superDeals",
            //             "order": 1,
            //             // "required": true,
            //             // "formControlName": "MoveDate",
            //             // "value": lead.MoveDate
            //         },
            //         // {
            //         //     "label": "Get Price",
            //         //     "fieldType": "button",
            //         //     "formControlName": "done",
            //         //     "order": 2
            //         // },
            //     ]
            // },
            // {
            //     "id": "",
            //     "title": "choose your flexible super deal pricing",
            //     "subTitle": "",
            //     "key": "date",
            //     "shortTitle": "",
            //     "goNextOnValid": true,
            //     // "footer": true,
            //     "fields": [
            //         {
            //             "fieldType": "pricingOptions",
            //             "order": 1,
            //             // "required": true,
            //             // "formControlName": "MoveDate",
            //             // "value": lead.MoveDate
            //         },
            //     ]
            // },
            // {
            //     "id": "",
            //     "title": "you’re All Set!",
            //     "subTitle": "Let’s review everything before we book your move.",
            //     "key": "date",
            //     "shortTitle": "",
            //     "goNextOnValid": true,
            //     // "footer": true,
            //     "fields": [
            //         {
            //             "fieldType": "bookMove",
            //             "order": 1,
            //             // "required": true,
            //             // "formControlName": "MoveDate",
            //             // "value": lead.MoveDate
            //         },
            //     ]
            // },
            // {
            //     "id": "",
            //     "title": "Book your move",
            //     "subTitle": "Pay a deposit of $25 and the rest on your move day.",
            //     "key": "date",
            //     "shortTitle": "",
            //     "goNextOnValid": true,
            //     // "footer": true,
            //     "fields": [
            //         {
            //             "fieldType": "payDeposit",
            //             "order": 1,
            //             // "required": true,
            //             // "formControlName": "MoveDate",
            //             // "value": lead.MoveDate
            //         },
            //     ]
            // },
            // {
            //         "id": "",
            //         "title": "",
            //         "subTitle": "",
            //         "key": "date",
            //         "shortTitle": "",
            //         "goNextOnValid": true,
            //         // "footer": true,
            //         "fields": [
            //             {
            //                 "fieldType": "affirmCancellation",
            //                 "order": 1,
            //                 // "required": true,
            //                 // "formControlName": "MoveDate",
            //                 // "value": lead.MoveDate
            //             },
            //         ]
            //     },
            // {
            //     "id": "",
            //     "title": "Let's Discuss Your Quote!",
            //     "key": "confirm",
            //     "shortTitle": "",
            //     "fields": [
            //         // {
            //         //     "fieldType": "couponInfo",
            //         //     "order": 1,
            //         //     // isVisible: () => couponDates.indexOf(moment(lead.MoveDate).format('MM-DD-YYYY')) > -1
            //         // },
            //         {
            //             "fieldType": "title",
            //             "value": {
            //                 "title": localStorage.getItem("refferalCode"),
            //                 'subTitle': "Your Movingful Code"
            //             },
            //             "order": 1,
            //             // isVisible: () => couponDates.indexOf(moment(lead.MoveDate).format('MM-DD-YYYY')) > -1
            //         },
            //         {
            //             "label": "First Name",
            //             "fieldType": "textField",
            //             "required": true,
            //             "formControlName": "FirstName",
            //             "value": lead.FirstName,
            //             "order": 2
            //         },
            //         {
            //             "label": "Phone",
            //             "fieldType": "textField",
            //             "formControlName": "Telephone",
            //             "required": true,
            //             "keyboardType": "tel",
            //             "validators": {
            //                 // Regex for USA phone pattern validation
            //                 "custom": /^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/
            //             },
            //             "mask": ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
            //             "value": lead.Telephone,
            //             "order": 3
            //         },
            //         {
            //             "label": "CONTINUE",
            //             "fieldType": "button",
            //             "formControlName": "done",
            //             // "keyboardType": "tel",
            //             // "mask": ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
            //             // "value": "",
            //             "order": 4
            //         },
            //     ]
            // }
        ]
    }
}
